import { isBillingInterval, isPlanTier } from "@reactive-resume/utils";
import { useEffect } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";

import {
  checkoutPathForPlan,
  peekSelectedPlan,
  stashSelectedPlanFromSearch,
} from "@/client/libs/selected-plan";
import { useResumes } from "@/client/services/resume";
import { useAuthStore } from "@/client/stores/auth";

export const GuestGuard = () => {
  const user = useAuthStore((state) => state.user);
  const isLoggedIn = !!user;
  const { resumes, loading } = useResumes({ enabled: isLoggedIn });

  const [searchParams] = useSearchParams();

  useEffect(() => {
    stashSelectedPlanFromSearch(searchParams);
  }, [searchParams]);

  if (isLoggedIn) {
    const explicit = searchParams.get("redirect");
    if (explicit) return <Navigate to={explicit} />;

    if (!user?.planTier) {
      const plan = searchParams.get("plan");
      if (isPlanTier(plan)) {
        const intervalParam = searchParams.get("interval");
        const interval = isBillingInterval(intervalParam) ? intervalParam : "monthly";
        return <Navigate to={checkoutPathForPlan(plan, interval)} replace />;
      }

      const selected = peekSelectedPlan();
      if (selected) {
        return <Navigate to={checkoutPathForPlan(selected.plan, selected.interval)} replace />;
      }
    }

    if (loading) return null;
    if (!resumes?.length) {
      if (user?.planTier) return <Navigate to="/onboarding" replace />;
      return <Navigate to="/dashboard" />;
    }

    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};
